async function orderSelectionMap() {
    if (!document.querySelector('.js-store-selection-map')) return;

    const pickupPointsData = await getStoresData();

    updateStoreSelectionInfo();

    ymaps.ready(init);

    function init() {
        const storeSelectionMap = document.querySelector('.js-store-selection-map');
        const mapWrapper = storeSelectionMap.closest('.js-map-wrapper');
        const mapList = mapWrapper.querySelector('.js-map-list');

        const config = new MyMap(storeSelectionMap, {
            center: [0, 0],
        })

        for (let [city, data] of Object.entries(pickupPointsData)) {
            const collection = new ymaps.GeoObjectCollection();

            data.forEach(store => {
                const placemark = config.createPlacemark(store);

                generateItemList(placemark, store)

                collection.add(placemark)
            })

            config.map.geoObjects.add(collection);
        }

        config.map.setBounds(config.map.geoObjects.getBounds(), {
            checkZoomRange: true
        });

        const selectionSearch = document.querySelector('.store-selection__search');

        selectionSearch.addEventListener('input', (e) => {
            const value = e.target.value;

            const items = document.querySelectorAll('[data-store-id]');

            items.forEach(item => {
                if (item.textContent.includes(value)) {
                    item.classList.remove('hide')
                } else {
                    item.classList.add('hide')
                }
            })
        })

        function generateItemList(placemark, data) {
            const isActive = data.id === state.selectedStoreID;

            const li = document.createElement('li');
            li.className = 'store-selection__item js-store-selection-btn';
            li.dataset.storeId = data.id;

            if (isActive) {
                li.classList.add('active')
            }

            li.innerHTML += `
				<h3 class="store-selection__item-title">${data.address}</h3>
                <div class="store-selection__item-info">
                    <p>Срок хранения заказа: ${data.storage}</p>
                    <p>Будет готов к отгрузке: ${data.receiving}</p>
                </div>
                <button class="store-selection__item-btn button button--trans">${isActive ? 'Выбран' : 'Выбрать'}</button>
			`

            li.addEventListener('click', (e) => {
                if (!e.target.closest('.js-store-selection-btn')) return

                const isBtnClick = e.target.closest('.store-selection__item-btn');

                if (isBtnClick) {
                    state.selectedStoreID = +li.dataset.storeId;
                    updateSelectedStore();
                    changeStoreID();
                    modals.closeModal(null, '#store-selection')

                    return;
                }

                if (!placemark.balloon.isOpen()) {
                    placemark.balloon.open();
                } else {
                    placemark.balloon.close();
                }
            })

            mapList.append(li)
        }
    }
}

function updateStoreSelectionInfo() {
    if (!document.querySelector('.page-order__itemSelection-map'))  return;

    const wrapper = document.querySelector('.page-order__itemSelection');

    const configStore = state.selectedStore;

    if (configStore && wrapper) {
        const btn = document.querySelector('[href="#store-selection"]');
        btn.textContent = 'Изменить пункт самовывоза';
        wrapper.innerHTML = `
            <p>${configStore.address}</p>
            <span>Срок хранения заказа:  ${configStore.storage}</span>
            <span>Будет готов к отгрузке: ${configStore.receiving}</span>
            <div class="page-order__itemSelection-map"></div>
        `

        const map = wrapper.querySelector('.page-order__itemSelection-map');

        ymaps.ready(function() {
            const mapConfig = new MyMap(map, {
                center: configStore.coords,
            })

            mapConfig.map.geoObjects.add(new ymaps.Placemark(configStore.coords, {}, {
                iconLayout: ymaps.templateLayoutFactory.createClass(`
                <div class="placemark">
                    <div class="placemark__content">
                        <div class="placemark__icon">
                            <svg>
                                <use xlink:href="#map-pin"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            `),
                iconShape: {
                    type: 'Circle',
                    coordinates: [0, 0],
                    radius: 41,
                },
            }));
        });

        wrapper.classList.add('active');
    }
}
